import { Sidebar } from 'primereact/sidebar';
import React, { useEffect, useState, useRef } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import ImageForm from './ImageForm';
import ImageItem from './ImageItem';
import { CONSTANT } from '../../../../utils/constants';
import { privateFetch } from '../../../../utils/apiHelper';
import slugify from 'react-slugify';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useToastContext } from '../../../../contexts/ToastContext';
import { confirmDialog } from 'primereact/confirmdialog';

function MultipleImagePanel({ images, onValidate, loading, isOpen, onClose }) {
  const [tmpImages, setTmpImages] = useState(images);
  const [imageLoading, setImageLoading] = useState(false);
  const { accountContext } = useAccountContext();
  const { showToast } = useToastContext();
  const [validate, setValidate] = useState(false);
  const fileUploadRef = useRef(null);

  useEffect(() => {
    setTmpImages(images);
  }, [images]);

  const handleAddImage = (image) => {
    setTmpImages((prevImages) => [...(prevImages || []), image]);
    setValidate(true);
  };

  const confirmDeletion = (image) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette image ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteImage(image)
    });
  };

  const handleDeleteImage = (image) => {
    setTmpImages((prevImages) => prevImages.filter((img) => img.id !== image.id));
    setValidate(true);
  };

  useEffect(() => {
    if (validate) {
      onValidate(tmpImages);
    }
    setValidate(false);
  }, [validate]);

  const handleImageUpdate = (imageToUpdate) => (event) => {
    if (event.files[0].size > CONSTANT.maxImageSize) {
      showToast('warn', '10Mo max.');
      return;
    }

    setImageLoading(true);
    const file = event.files[0];
    const imageForm = new FormData();
    const title = file.title || file.name || 'image-update';
    imageForm.append('title', slugify(title));
    imageForm.append('file', file);

    privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/image/${imageToUpdate.id}/`,
      "L'image a bien été modifiée",
      imageForm,
      false,
      true
    ).then((res) => {
      setImageLoading(false);
      setTmpImages((prev) => prev.map((img) => (img.id === res.id ? res : img)));
      showToast('success', "L'image a bien été modifiée");
    });

    fileUploadRef.current.clear();
  };

  const customHeader = (
    <React.Fragment>
      <h2 style={{ marginBottom: 0 }} className="text-slate-900 text-2xl font-medium">
        Gérer les images
      </h2>
    </React.Fragment>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      header={customHeader}
      visible={isOpen}
      maskStyle={{ backgroundColor: '#00000080' }}
      onHide={onClose}
      position="right">
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput label={'Images existantes'} className={'flex flex-col gap-y-3'}>
            {tmpImages &&
              tmpImages.map((i) => (
                <ImageItem
                  key={i.id}
                  className="w-full h-full"
                  deleteImage={() => confirmDeletion(i)}
                  updateImage={handleImageUpdate(i)}
                  image={i}
                  alt="Prévisualisation de la photo"
                  imageLoading={imageLoading}
                  fileUploadRef={fileUploadRef}
                />
              ))}

            {!tmpImages?.length && (
              <span className="italic mt-2 text-slate-400">Aucune image renseignée</span>
            )}
          </FormInput>

          {!loading && (
            <ImageForm
              image={undefined}
              setImage={handleAddImage}
              label="Nouvelle image"
              required={false}
            />
          )}
        </div>
      </div>
    </Sidebar>
  );
}

export default MultipleImagePanel;
